<template>
  <div role="status" aria-live="polite" class="ellipsis-container">
    <ion-skeleton-text
      :aria-hidden="true"
      v-if="isLoading"
      :animated="true"
      style="width: 100%; min-width: 80px; height: 20px"
    ></ion-skeleton-text>
    <div
      v-else
      class="ellipsis-item"
      v-for="item in quantity"
      :key="item"
      :aria-hidden="true"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <circle
          cx="6"
          cy="6"
          r="6"
          :class="item - 1 === activeIndex ? 'active' : 'inactive'"
        />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, withDefaults } from "vue";
import { IonSkeletonText } from "@ionic/vue";

interface Props {
  quantity: number;
  activeIndex: number;
  isLoading?: boolean;
}
withDefaults(defineProps<Props>(), {
  isLoading: false,
});
</script>

<style lang="scss" scoped>
.ellipsis-container {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-8);
  justify-content: center;
  circle {
    fill: var(--ion-color-primary);
    opacity: 1;
    &.inactive {
      opacity: 0.2;
    }
    transition: opacity 0.3s ease-in-out;
  }
}
</style>
